import { render, staticRenderFns } from "./LotteryResultPopup.vue?vue&type=template&id=2d01f39c&scoped=true"
import script from "./LotteryResultPopup.vue?vue&type=script&lang=ts"
export * from "./LotteryResultPopup.vue?vue&type=script&lang=ts"
import style0 from "./LotteryResultPopup.vue?vue&type=style&index=0&id=2d01f39c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01f39c",
  null
  
)

export default component.exports